import './GalleryWall.css';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Importazione esatta delle immagini dalla cartella assets
import img1 from '../assets/images/soul-rock-cafe-rak.webp';
import img2 from '../assets/images/2.Reception.png';
import img3 from '../assets/images/3.Attesa reception.png';
import img4 from '../assets/images/4.Back_to_the_Future.PNG';
import img5 from '../assets/images/tour/ed209.webp';
import img6 from '../assets/images/tour/robocop.webp';
import img7 from '../assets/images/7.SalaCocktail-Michael-Jackson.png';
import img8 from '../assets/images/bancone-ferro.webp';
import img9 from '../assets/images/9.Cucina-Vista.png';
import img10 from '../assets/images/10.Cucina-Hamburger.png';
import img11 from '../assets/images/10.Parete-Jeans.png';
import img12 from '../assets/images/11. Alien_vs_Predator.PNG';
import img13 from '../assets/images/12. Robocop_vs_Terminator.PNG';
import img14 from '../assets/images/13.Shop-Soul-Rock.png';
import img15 from '../assets/images/14.Ologramma-Freddie.png';

const images = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15
];

const Gallery = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Apre l'immagine a tutto schermo
  const openLightbox = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  // Chiude il visualizzatore
  const closeLightbox = () => {
    setIsOpen(false);
  };

  // Immagine precedente
  const goToPrev = (e) => {
    e.stopPropagation(); // Evita che il click chiuda la lightbox
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  // Immagine successiva
  const goToNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <div className="gallery-wall">
      <h1 style={{ color: '#ffa74f', fontSize: '2.5rem', marginBottom: '2.5rem', textTransform: 'uppercase' }}>
        {t('gallery')}
      </h1>

      {/* GRIGLIA IMMAGINI */}
      <div className="gallery-grid">
        {images.map((src, index) => (
          <div key={index} className="gallery-item" onClick={() => openLightbox(index)}>
            <img src={src} alt={`Soul Rock ${index + 1}`} className="gallery-image" />
          </div>
        ))}
      </div>

      {/* MODALE FULLSCREEN (LIGHTBOX) */}
      {isOpen && (
        <div className="lightbox" onClick={closeLightbox}>
          <span className="close-btn" onClick={closeLightbox}>&times;</span>
          <span className="nav-arrow left-arrow" onClick={goToPrev}>&#10094;</span>
          <img 
            src={images[currentIndex]} 
            alt={`Soul Rock Enlarged ${currentIndex + 1}`} 
            className="lightbox-img" 
            onClick={(e) => e.stopPropagation()} 
          />
          <span className="nav-arrow right-arrow" onClick={goToNext}>&#10095;</span>
        </div>
      )}

      {/* STILI SPECIFICI PER LA GALLERIA */}
      <style>{`
        .gallery-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));
          gap: 2rem;
          max-width: 1200px;
          margin: 0 auto;
        }

        .gallery-item {
          position: relative;
          cursor: pointer;
          border-radius: 8px;
          height: 250px; 
        }

        .gallery-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 8px;
          transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94), box-shadow 0.4s ease;
          position: relative;
          z-index: 1;
        }

        /* EFFETTO HOVER 30% E ILLUMINAZIONE LATERALE */
        .gallery-image:hover {
          transform: scale(1.3);
          z-index: 10;
          box-shadow: -20px 0px 30px -10px #f07c00, 20px 0px 30px -10px #f07c00;
        }

        /* STILI LIGHTBOX */
        .lightbox {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.95);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }

        .lightbox-img {
          max-width: 85vw;
          max-height: 85vh;
          border-radius: 8px;
          box-shadow: 0 0 40px rgba(240, 124, 0, 0.5);
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }

        .close-btn {
          position: absolute;
          top: 20px;
          right: 30px;
          color: white;
          font-size: 3.5rem;
          font-weight: bold;
          cursor: pointer;
          transition: color 0.3s;
          z-index: 10000;
        }

        .close-btn:hover {
          color: #f07c00;
        }

        .nav-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          color: rgba(255, 255, 255, 0.7);
          font-size: 4rem;
          font-weight: bold;
          cursor: pointer;
          user-select: none;
          padding: 1rem;
          transition: color 0.3s, transform 0.3s;
          z-index: 10000;
        }

        .nav-arrow:hover {
          color: #f07c00;
          transform: translateY(-50%) scale(1.1);
        }

        .left-arrow { left: 2vw; }
        .right-arrow { right: 2vw; }

        @media (max-width: 768px) {
          .nav-arrow { font-size: 2.5rem; }
          .gallery-image:hover { transform: scale(1.1); /* Su mobile uno scale minore è meglio */ }
        }
      `}</style>
    </div>
  );
};

export default Gallery;
